export class TeamRoleEdit
{
    public id = null;
    public name = '';
    public active = true;
    public description: string = null;
    public pcp = false;
    public teamType: any;
}

export interface TeamRoleList
{
    id: number;
    name: string;
    description: string;
    active: boolean;
    pcp: boolean;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
